/* eslint-disable */
import { useContext } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";

import { AtIcon, IconPhone, InfoCircle } from "../../common/icons";
import { AddressForm } from "../../components/AddressLocation";
import { LocalizationContext } from "../../App";
import { useGetBrokerQuery, useGetPoliciesQuery } from "../../store/policiesSlice";

const Broker = () => {
  const { infoCode } = useParams();
  const navigate = useNavigate();
  const { currentData: policies = [], isLoading: arePoliciesLoading } = useGetPoliciesQuery();
  const { data: broker, isLoading: isBrokerLoading } = useGetBrokerQuery(policies[0]?.uniqueIdentifier ?? skipToken);
  const l10n = useContext(LocalizationContext);

  if (arePoliciesLoading || isBrokerLoading) return (
    <div className="loading-screen flex flex-col justify-center items-center">
      <div className="text-body text-xl">{l10n.common.loading}</div>
    </div>
  );

  if (!broker || !policies) {
    navigate("/");
    return <></>;
  }

  const displayForm = (
    <div className="flex flex-col">
      <div className="card relative">
        <div className="card-body flex flex-col gap-3">
          <AddressForm
            isPreviewMode={true}
            inputAddressData={broker.locationAddress}
            onChange={() => {}}
          />
          {broker.phone && <div className="flex items-center gap-4">
            <IconPhone className={"w-5 h-5 stroke-2 stroke-card"} />
            <span className="text-card">
              {broker.phone.replace(/\s/g, "")}
            </span>
          </div>}
          <div className="flex items-center gap-4">
            <AtIcon className={"w-5 h-5 stroke-2 fill-card"} />
            <span className="text-card">{broker.email}</span>
          </div>
        </div>
      </div>

      {broker.phone && <a href={'tel:'+ broker.phone}>
        <button className="btn btn-primary">
          {l10n.btn.callBroker}
        </button>
      </a>}
    </div>
  );

  return (
    <>
      <h2>
        {l10n.title.yourBroker}
        {broker.firstName && (
          <>
            <span>,{" "}</span>
            <span className="font-medium">{broker.firstName} {broker.lastName}</span>
          </>
        )}
      </h2>

      {infoCode && (
        <div className="notification notification-info mt-3 mb-6">
          <InfoCircle className="w-[24px] h-[24px] shrink-0 fill-info" />
          /* TODO: Notify Chris that this is potentially missed instance of an identical translation (Kundenberater:in) */
          <span className="text-info">{l10n.notice.pleaseContactYourAdvisor}</span>
        </div>
      )}

      {displayForm}
    </>
  );
};

export default Broker;
